import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import GoogleMeetStudentCarouselWidget from "../googleMeetStudentCarouselWidget/GoogleMeetStudentCarouselWidget";
import googleMeetImgTeacher from "../../../../assests/googleMeet/googleMeetWidgetTeacherMeetNotActive.png";

const GoogleMeetCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const { isStudent } = useSelector(state => state.auth);

    if (isStudent)
        return <GoogleMeetStudentCarouselWidget />;

    return (
        <WidgetCarouselCard
            color="#7ED0FF"
            title={texts.googleMeet}
            image={googleMeetImgTeacher}
            imageAlt={texts.googleMeet}
            link={`/${pathRouts.GOOGLEMEET}`}
        />
    );
};

export default GoogleMeetCarouselWidget;
